<!--
  A real button, not a click-handled <span>: the toggle is now keyboard reachable and exposes its state
  through aria-pressed. Both labels live inside the one button so the pressed state can never diverge
  between the phone ("E") and desktop ("Einheit") variants. `text-gray-500` (4.83:1 on white), not the
  `text-gray-400` (2.53:1) the old spans used — axe flagged it once this became real, labelled UI.
-->
<button type="button" data-testid="einheit-toggle" (click)="toggleUnit()" [disabled]="disabled()"
        [attr.aria-pressed]="unit()"
        [class.!text-black]="unit()"
        class="fw-bold shrink-0 cursor-pointer select-none pr-2 text-gray-500 transition-colors
               disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline
               focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-theme-primary-500"
        title="Menge als Einheiten des Artikels rechnen">
  <span class="hidden md:inline">Einheit</span>
  <span class="md:hidden">E</span>
</button>

<!--
  Amount (+ price) as ONE bordered control: the ring/rounding sits on this wrapper and the inputs are bare,
  so the group looks like a single field while every part is a normal flex item. `min-w-0` on the wrapper
  and on the inputs is what lets the row shrink instead of overflowing on narrow screens.
-->
<div class="cq-field flex min-w-0 grow items-stretch"
     [class.ring-yellow-600]="highlight()" [class.ring-gray-300]="!highlight()"
     [class.cq-field-disabled]="disabled()">
  <label class="flex min-w-0 grow items-center gap-1 pl-3"
         [class.border-r]="showPrice()" [class.border-gray-300]="showPrice()">
    <span class="sr-only">Menge</span>
    <!-- The prefix is a flex sibling of the input — no overlay, no measured padding (#230). -->
    @if (prefix(); as text) {
      <span data-testid="unit-prefix" aria-hidden="true"
            class="shrink-0 select-none whitespace-nowrap text-gray-500 sm:text-sm">{{ text }}</span>
    }
    <input type="number" inputmode="decimal" placeholder="0.00"
           [ngModel]="value()" (ngModelChange)="value.set($event)" [ngModelOptions]="{standalone: true}"
           [disabled]="disabled()"
           [attr.name]="'amount_' + index()"
           class="cq-field-input w-full min-w-0 pr-2">
  </label>

  @if (showPrice()) {
    <label class="flex shrink-0 items-center gap-1 pl-2">
      <span class="sr-only">Preis in Euro</span>
      <span aria-hidden="true" class="select-none text-gray-500 sm:text-sm">&euro;</span>
      <input type="number" inputmode="decimal" step="0.01" placeholder="0.00"
             [ngModel]="price()" (ngModelChange)="price.set($event)" [ngModelOptions]="{standalone: true}"
             [disabled]="disabled()"
             [attr.name]="'price_' + index()"
             class="cq-field-input w-16 min-w-0 pr-2">
    </label>
  }
</div>
